import usePermissions from "hooks/usePermissions";
import CommonActionIconButtons from "./CommonActionIconButtons";
import GuestMenu from "./GuestMenu";
import ShipperActionIconButtons from "./ShipperActionIconButtons";
import ProviderActionIconButtons from "./ProviderActionIconButtons";

interface ActionIconButtonsProps {
  isQuickRequest: boolean;
  shipmentId: string;
  tabTitle: string;
  isLoading: boolean;
  isConsolidated?: boolean;
  isGuest?: boolean;
}

export default function ActionIconButtons({
  isQuickRequest,
  shipmentId,
  tabTitle,
  isLoading,
  isConsolidated,
  isGuest,
}: ActionIconButtonsProps) {
  const { permissions } = usePermissions();
  const { user_type } = JSON.parse(permissions || "{}");
  const isShipper = user_type === "shipper";

  return (
    <div className="d-flex align-items-center gap-sm">
      {isGuest ? (
        <GuestMenu />
      ) : (
        <>
          {isShipper ? (
            <ShipperActionIconButtons
              isQuickRequest={isQuickRequest}
              shipmentId={shipmentId}
              tabTitle={tabTitle}
              isLoading={isLoading}
              isConsolidated={isConsolidated}
            />
          ) : (
            <ProviderActionIconButtons
              isQuickRequest={isQuickRequest}
              shipmentId={shipmentId}
              tabTitle={tabTitle}
              isLoading={isLoading}
            />
          )}
          <CommonActionIconButtons isQuickRequest={isQuickRequest} shipmentId={shipmentId} tabTitle={tabTitle} />
        </>
      )}
    </div>
  );
}
